// extracted by mini-css-extract-plugin
export var header = "_vn-1";
export var maskBottom = "_vn-6";
export var maskMiddle = "_vn-7";
export var maskTop = "_vn-5";
export var root = "_vn-0";
export var scrollDownButton = "_vn-3";
export var scrollDownButtonHidden = "_vn-4";
export var viewport = "_vn-2";